import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';


import App from './App.vue';

import Home from './view/homeVue.vue';
import Animaux from './view/animauxVue.vue';
import Legal from './view/legalVue.vue';
import Sos from './view/sosVue.vue';
import Ferme from './view/FermeVue.vue';
import Service from './view/serviceVue.vue';


import Adopter from './view/adopteVue.vue';
import Partenaire from './view/partenaireVue.vue';
import Shops from './view/shopVue.vue';
import Besoins from './view/besoinsVue.vue';
import Information from './view/informationVue.vue';
import Actu from './view/actuVue.vue';
import AnimalPage from './view/animauxDetails.vue';
import NewsPage from './view/newsPage.vue';
import Signalement from './view/signalementVue.vue';
import Fourriere from './view/fourriereVue.vue';
import Faq from './view/faqVue.vue';
import Benevole from './view/benevoleVue.vue';
import Cec from './view/cecVue.vue';
import Tarif from './view/tarifsVue.vue';
import InfoRefuge from './view/infoRefuge.vue';
import Contact from './view/contactVue.vue';
import Dons from './view/donVue.vue';
import ContentPage from './view/contentPage.vue';

// ══════════════════════════════════════════════
// ▼▼▼  CONFIGURATION DU SITE — tout modifier ici  ▼▼▼
// ══════════════════════════════════════════════
const _short = "Coeurs de Mastins"; // nom court
const _full = "Coeurs de Mastins"; // nom complet
const _loc = "Haut-Rhin (68)"; // département
const _region = "Alsace"; // région
const _near = "Mulhouse"; // villes proches (pour le SEO)
// ══════════════════════════════════════════════

const _alt = `association de protection animale ${_short} dans le ${_loc}`;

export const SEO = {
    idSite: 52, // ← Coeurs de Mastins
    shortName: _short,
    fullName: _full,
    location: _loc,
    altSuffix: _alt,
    siteName: _short,
    defaultTitle: `${_short} | Sauvetage et adoption de Mastins espagnols — ${_loc}`,
    defaultDescription: `${_short} est une association de protection animale spécialisée dans le sauvetage et l'adoption de Mastins espagnols, basée dans le ${_loc}, en ${_region}. Adoptez un chien, devenez famille d'accueil.`,
    faviconUrl: "https://admin.asso-refuge.fr/images/1774387460_logo.jpg",
    googleAnalyticsId: "G-VWM4BD1BM2", // ← ID Google Analytics à mettre à jour

    // Réseaux sociaux — laisser null pour masquer le lien
    social: {
        facebook: null, // ← à mettre à jour avec le lien Facebook de Coeurs de Mastins
        youtube: null,
    },

    // SEO par page : title + description
    pages: {
        '/': {
            title: `${_short} | Adoption Mastin espagnol — ${_loc}`,
            description: `${_short} sauve et place des Mastins espagnols en famille en ${_region}. Adoptez un chien, devenez famille d'accueil ou soutenez notre association bénévole basée à ${_near}.`,
        },
        '/animaux': {
            title: `Mastins espagnols à adopter | ${_short} — ${_loc}`,
            description: `Chiens et chiots Mastins espagnols à adopter. Consultez tous les animaux disponibles placés en famille d'accueil par ${_short} dans le ${_loc}.`,
        },
        '/adopte': {
            title: `Les adoptés | ${_short} — ${_loc}`,
            description: `Découvrez les Mastins espagnols qui ont trouvé une famille grâce à ${_short}. Histoires de sauvetage et d'adoption réussie en ${_region}.`,
        },
        '/besoins': {
            title: `Nos besoins | ${_short} — ${_loc}`,
            description: `Aidez ${_short} : dons de matériel, nourriture et bénévolat. Chaque geste compte pour les Mastins espagnols sauvés dans le ${_loc}.`,
        },
        '/sos': {
            title: `SOS Animaux | ${_short} — ${_loc}`,
            description: `Signalez un animal en danger ou en détresse. ${_short} intervient pour secourir les animaux abandonnés ou maltraités en ${_region}.`,
        },
        '/contact': {
            title: `Contact | ${_short} — ${_loc}`,
            description: `Contactez ${_short}, association de protection animale spécialisée dans le Mastin espagnol, basée dans le ${_loc}, ${_region}.`,
        },
        '/partenaires': {
            title: `Nos partenaires | ${_short}`,
            description: `Découvrez les partenaires vétérinaires, associations et refuges espagnols qui soutiennent ${_short} pour la protection du Mastin espagnol.`,
        },
        '/actualites': {
            title: `Actualités | ${_short}`,
            description: `Toutes les actualités de ${_short} : sauvetages, adoptions réussies, événements et nouvelles de notre association spécialisée dans le Mastin espagnol.`,
        },
        '/faq': {
            title: `FAQ — Questions fréquentes | ${_short}`,
            description: `Toutes les réponses à vos questions sur l'adoption, les familles d'accueil et le fonctionnement de ${_short}.`,
        },
        '/dons': {
            title: `Faire un don | ${_short}`,
            description: `Soutenez ${_short} par un don financier ou matériel. Votre contribution aide directement les Mastins espagnols sauvés par notre association bénévole.`,
        },
        '/legal': {
            title: `Mentions légales | ${_short}`,
            description: `Mentions légales du site officiel de ${_short}, association loi 1901 de protection animale dans le ${_loc}.`,
        },
        '/qui-sommes-nous': {
            title: `Qui sommes-nous | ${_short}`,
            description: `${_short} : association bénévole spécialisée dans le sauvetage et l'adoption du Mastin espagnol. Histoire, missions, équipe et actions en ${_region}.`,
        },
        '/shops': {
            title: `Boutique solidaire | ${_short}`,
            description: `Boutique solidaire de ${_short}. Chaque achat soutient directement les Mastins espagnols sauvés et placés en famille d'accueil.`,
        },
        '/signalement': {
            title: `Signaler une maltraitance animale | ${_short}`,
            description: `Signalez un cas de maltraitance ou d'abandon d'animal. ${_short} prend en charge et alerte les autorités compétentes en ${_region}.`,
        },
        '/recherche_famille': {
            title: `Recherche famille d'accueil | ${_short}`,
            description: `Devenez famille d'accueil pour ${_short}. Hébergez temporairement un Mastin espagnol en attente d'adoption et aidez notre association bénévole.`,
        },
        // Pages dynamiques issues de l'API (getPagess/52)
        '/page/22': {
            title: `Qui sommes-nous ? | ${_short}`,
            description: `Découvrez l'histoire et les missions de ${_short}, association spécialisée dans le sauvetage et l'adoption du Mastin espagnol.`,
        },
        '/page/23': {
            title: `Page Vétérinaire — Maladies méditerranéennes | ${_short}`,
            description: `Informations vétérinaires sur les maladies méditerranéennes (Leishmaniose, Ehrlichiose, Filariose) fréquentes chez les Mastins espagnols adoptés par ${_short}.`,
        },
        '/page/24': {
            title: `Refuges partenaires en Espagne | ${_short}`,
            description: `Découvrez les refuges partenaires espagnols qui collaborent avec ${_short} pour le sauvetage et le transfert des Mastins espagnols.`,
        },
        '/page/25': {
            title: `Nous aider | ${_short}`,
            description: `Soutenez ${_short} : dons, bénévolat, familles d'accueil. Plusieurs façons d'aider notre association pour la protection du Mastin espagnol.`,
        },
        '/page/26': {
            title: `Conditions d'adoption | ${_short}`,
            description: `Découvrez les conditions et les étapes pour adopter un Mastin espagnol via ${_short}. Frais d'adoption, visite de contrôle, contrat d'adoption.`,
        },
        '/page/27': {
            title: `Famille d'accueil | ${_short}`,
            description: `Devenez famille d'accueil pour ${_short} et hébergez temporairement un Mastin espagnol en attente d'adoption. Rôle, engagement et démarches.`,
        },
        '/page/28': {
            title: `Présentation du Mastin espagnol | ${_short}`,
            description: `Tout savoir sur le Mastin espagnol : caractère, caractéristiques, besoins et conseils pour bien accueillir ce chien imposant. Guide complet par ${_short}.`,
        },
    },
};

const routes = [
    { path: '/redirect', redirect: '/' },
    { path: '/', component: Home },
    { path: '/partenaires', component: Partenaire },
    { path: '/faq', component: Faq },
    { path: '/shops', component: Shops },
    { path: '/besoins', component: Besoins },
    { path: '/sos', component: Sos },
    { path: '/actualites', component: Actu },
    { path: '/animaux_ferme', component: Ferme },
    { path: '/actions', component: Service },
    { path: '/animaux_trouve', component: Fourriere },
    { path: '/benevolat', component: Benevole },
    { path: '/adopte', component: Adopter },
    { path: '/legal', component: Legal },
    { path: '/info_refuge', component: Information },
    { path: '/animaux', component: Animaux },
    { path: '/signalement', component: Signalement },
    { path: '/dons', component: Dons },
    { path: '/cec', component: Cec },
    { path: '/contact', component: Contact },
    { path: '/qui-sommes-nous', component: InfoRefuge },
    { path: '/tarifs', component: Tarif },
    { path: '/publication/:id', component: NewsPage },
    { path: '/animaux/:id', component: AnimalPage },
    { path: '/page/:id', component: ContentPage },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth',
            };
        } else {
            return { top: -50 };
        }
    },
});

// Mise à jour dynamique du titre et de la meta description à chaque navigation
router.afterEach((to) => {
    const pageSeo = SEO.pages[to.path] || {};
    document.title = pageSeo.title || SEO.defaultTitle;

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
        metaDesc.setAttribute('content', pageSeo.description || SEO.defaultDescription);
    }
});

// Créer l'application Vue
const app = createApp(App);
app.config.globalProperties.$idSite = SEO.idSite;
app.config.globalProperties.$seo = SEO;

// Utiliser le routeur
app.use(router);

// Monter l'application
app.mount('#app');